import { graphql } from "react-relay";
import { SuggestionAction } from "@components/suggestion-action";
import { SuggestionBody } from "@components/suggestion-body";
import { SuggestionCardHeader } from "@components/suggestion-card-header";

export const fragments = {
  org: graphql`
    fragment SuggestionCard_org on Org {
      ...SuggestionAction_org
      ...SuggestionBody_org
      ...SuggestionCardHeader_org
    }
  `,
  feedSuggestion: graphql`
    fragment SuggestionCard_feedSuggestion on FeedSuggestion {
      ...SuggestionAction_feedSuggestion
      ...SuggestionCardHeader_feedSuggestion
      id
      suggestionId
      suggestionType
      suggestionPayload {
        ...SuggestionBody_suggestionPayload
        __typename
        ... on SuggestionResultChromeExtensionTipPayload {
          tipType
        }
        ... on SuggestionResultMissingUserConfigurationPayload {
          configurationType
        }
      }
      primaryAction {
        type
      }
    }
  `,
};
